import { THEME } from "@/config/theme";

// Atmospheric canvas backdrop (design mock): a warm radial gradient wash, a very
// faint white dot grid, and a soft indigo bloom at the optical centre. Rendered
// behind <ReactFlow> (which is made transparent in Viewport) so these show
// through. Purely decorative — pointer-events:none, aria-hidden. All values come
// from THEME.raw so the look is tuned in one place.
export default function CanvasAtmosphere() {
  return (
    <div
      data-testid="canvas-atmosphere"
      aria-hidden
      className="absolute inset-0 z-0 pointer-events-none"
    >
      <div className="absolute inset-0" style={{ backgroundImage: THEME.raw.canvasGradient }} />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: THEME.raw.dotGridImage,
          backgroundSize: THEME.raw.dotGridSize,
          opacity: THEME.raw.dotGridOpacity,
        }}
      />
      <div className="absolute inset-0" style={{ backgroundImage: THEME.raw.canvasBloom }} />
    </div>
  );
}
